const DEFAULT_MAX_WIDTH = 540;
const DEFAULT_COLUMNS = 10;
const DEFAULT_BODY_FONT_SIZE = 12;

export interface RemOptions {
  /** 页面最大适配宽度。 */
  maxWidth?: number;
  /** 页面宽度切分列数。 */
  columns?: number;
}

/**
 * 初始化移动端 rem 根字号适配。
 */
export function setupRem({
  maxWidth = DEFAULT_MAX_WIDTH,
  columns = DEFAULT_COLUMNS,
}: RemOptions = {}) {
  let resizeTimer = 0;

  const refreshBodyFontSize = () => {
    if (document.body) document.body.style.fontSize = `${DEFAULT_BODY_FONT_SIZE}px`;
  };

  const refreshRem = () => {
    const pageWidth = Math.min(document.documentElement.clientWidth, maxWidth);
    document.documentElement.style.fontSize = `${pageWidth / columns}px`;
  };

  const scheduleRefresh = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(refreshRem, 100);
  };

  const handlePageShow = (event: PageTransitionEvent) => {
    if (event.persisted) scheduleRefresh();
  };

  refreshRem();
  if (document.body) {
    refreshBodyFontSize();
  } else {
    document.addEventListener('DOMContentLoaded', refreshBodyFontSize, { once: true });
  }
  window.addEventListener('resize', scheduleRefresh);
  window.addEventListener('pageshow', handlePageShow);

  return () => {
    window.clearTimeout(resizeTimer);
    document.removeEventListener('DOMContentLoaded', refreshBodyFontSize);
    window.removeEventListener('resize', scheduleRefresh);
    window.removeEventListener('pageshow', handlePageShow);
  };
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  setupRem();
}
